// Static option lists for person profile fields (Add person + Profile edit).
// Inline lists until the backend exposes them; values are display strings,
// stored and sent verbatim — CONFIRMED, as are the employmentType/nationality
// filter wire keys.

export const EMPLOYMENT_TYPES = ['Full-time', 'Part-time', 'Contract', 'Temporary', 'Intern'];

export const NATIONALITIES = [
  'Saudi',
  'Egyptian',
  'Jordanian',
  'Lebanese',
  'Syrian',
  'Sudanese',
  'Yemeni',
  'Indian',
  'Pakistani',
  'Bangladeshi',
  'Filipino',
  'Nepali',
];
